  var initCoupons = function(couponsModel) {
    if(couponsModel.coupons != null) {
      for (var i = 0 ; i < couponsModel.coupons.length ; i++) {
          $(".pc_couponlist").append("<tr> <td> "+couponsModel.coupons[i].CouponCode+" </td> <td>"+ couponsModel.coupons[i].CouponValue+"</td> </tr>");
      }
    }
        
    $("#pcCoupons_desc").text(couponsModel.TileDescription).fadeIn(300);
  }
 
   var initFeedback = function(feedbackModel) {
        
    $("#pcFeedback_desc").text(feedbackModel.FeedbackTileDescription).fadeIn(300);

    for (var i = 0 ; i < feedbackModel.feedbackList.length ; i++) {
		$(".pc_feedbacklist").append("<table class='table table-striped table-bordered table-hover'> <tbody> <tr> <td> Your Rating</td> <td> "+feedbackModel.feedbackList[i].feedbackRating+" </td></tr><tr> <td> Your Feedback</td> <td>"+
                                              feedbackModel.feedbackList[i].feedback+"</td></tr><tr> <td> Shop owners response</td> <td>"+
                                              feedbackModel.feedbackList[i].feedbackTenantResponse+"</td> </tr> </tbody>  </table>");
	}
  }
 
  var initNotifications = function(notificationModel) {
    // hide feedback for now
    $("#pcNotificationDetails").hide();
    // uncomment the following once we have notifications
    //var i =0;
    //if ( i < notificationModel.products.length){
    //	setInterval(function(){
    //  i == (notificationModel.products.length - 1) ? i = 0 : i++;
    //  $('#pcNewProducts img').fadeOut('slow');
    //  $('#pcNewProducts img').attr('src',notificationModel.products[i].productImageUrl);
    //  $('#pcNewProducts a').attr('href', "/products/"+ notificationModel.products[i].productHandle);
    //  $('#pcNewProducts img').fadeIn('slow');
    //}, 3000);
    //}
    
    //$("#pcNotification").next().text(notificationModel.TileDescription).fadeIn(300);

  }
  
  var initPoints = function(pointsModel) {
  	$("#pc_loyaltyPointCount").text(pointsModel.loyaltyPointCount);
    $("#pc_loyaltyPointRedeemValue").text(pointsModel.loyaltyPointRedeemValue);
    $("#pc_loyaltyPointper100Dollar").text(pointsModel.loyaltyPointper100Dollar);
    $("#pc_giftCardLoyaltyPointCount").text(pointsModel.giftCardLoyaltyPointCount);
    if(pointsModel.giftCardCodes != null){
      for(var i=0; i< pointsModel.giftCardCodes.length; i++){
        var ele = "<div>$50 Gift card code: <span class=\"pc_loyaltyPointGiftCardDetails\">"+pointsModel.giftCardCodes[i]+"</span></div>";
        $("#pc_loyaltyPointGiftCardContainer").add(ele);
      }
    }
    
    $("#pcPoints_desc").text(pointsModel.TileDescription).fadeIn(300);
  }
  
  var pc = new Object();
  
  pc.isReady = function() {
  	return true;
  }
  
  pc.init = function(customer_id) {
    var url = "/apps/preferredCustomer";
    $.get(
      url,
      {
        CustomerId: customer_id 
      },
      function (data, status) {
        
        pc.Model  = data;
        initCoupons(pc.Model.couponsModel);
        initPoints(pc.Model.pointsModel);
        initNotifications(pc.Model.notificationModel);
        initFeedback(pc.Model.feedbackModel);
        $(".pc_viewportHeader").fadeIn(300);
        
        for (var count = 0; count < 10; count++) {
          $("#pcstart").animate({right: "20px"}, 100 );
          $("#pcstart").animate({right: "0px"}, 100 );
        }
      }
    );
  }
    
  pc.RequestRedeemPoints = function(customer_id) {
    var url = "/apps/preferredCustomer";
    $.get(
      url,
      {
        RedeemPoints: 1,
        CustomerId: customer_id 
      },
      function (data, status) {
        
      }
    );
  }
    
    pc.SubmitFeedback = function(customer_id) {
      		$('#pc_feedbackRating_submit_error').hide(200);
      		$('#pc_feedbackRating_submit_success').hide(200);
      		$('#pc_feedbackRating_submit').html('Save in progress..');
            var urlVal = 'https://preferredcustomerapp.azurewebsites.net/api/client/submitfeedback';

            var dataObj = {
                "shopName": pc.Model.shopName,
              	"customerId": customer_id,
                "satisfactionRating": pc.rating,
                "feedbackComments": $("#pc_feedback").val()
            };

            $.ajax({
                url: urlVal,
                type: 'POST',
                headers: { 'X-preferredCustomerApp-hmacCode': pc.Model.key, 'shopName': pc.Model.shopName },
                contentType: 'application/json; charset=utf-8',
                data: JSON.stringify(dataObj),
                dataType: "json",
                success: function (data) {
                  $('#pc_feedbackRating_submit_success').show(200);
                  $('#pc_feedbackRating_submit').html('Submit Feedback');
                  $("#pc_feedback").val('');
                },
              	error: function(textStatus, errorThrown)  {
                  if(textStatus.status != 200) {
                  $('#pc_feedbackRating_submit_error').show(200);
                  } else {
                    $('#pc_feedbackRating_submit_success').show(200);
                  }
                  $('#pc_feedbackRating_submit').html('Submit Feedback');
                }
            });
}
  // Set up helper functions
    var dismissWelcomeMsg = function() {
    	$(".pc_viewportHeader").hide(350);
    }  
    
  var toggleFeature = function(featureArea) {
    $("#pc_Menu").hide();
    $("#"+featureArea).fadeIn(300);
  }
  
  var togglePointsFeature = function() {
  	toggleFeature("pcPointsDetails"); 
  }
  
  var toggleCouponsFeature = function() {
      toggleFeature("pcCouponsDetails");  	
  }
  
  var toggleFeedbackFeature = function() {
      toggleFeature("pcFeedbackDetails");  	
  }
  
  var setupViewport = function() {
      // Set up viewport dimensions
      $("#pcviewportCover").width($(window).width());
      $("#pcviewportCover").height($(window).height());
      if($(window).width() > 410){
        $("#pc_viewport").width(385);
        $("#closepcViewport").width($(window).width()-395);
      } else {
        $("#pc_viewport").width(295);
        $("#closepcViewport").width($(window).width()-305);
	  }
		
      $("#pc_Menu").show();
    }
  
  var isPCSetupByTenant = function() {
  var url = "/apps/preferredCustomer";
    $.get(
      url,
      function (data, status) {
        if(data) {
        // Show PC , since tenant setup is Complete
          $('.pc_launch').show(350);
        }
      }
    );
  }

  $(document).ready(function(){
    isPCSetupByTenant();
    setupViewport();
      
    $(window).resize(function(){ 
    setupViewport();
  });
    $(".pc_backToDefault").click(function(){
  	$(".pc_featureArea").hide();
    $("#pc_Menu").fadeIn(300);
  });


    // set up all click handlers
    $("#closepcViewport").click(function(){
    $("#pcstart").show();
    $('#pcviewportCover').fadeOut(300);
    $("#pcstart").css('right' , '0px');
    $('html, body').css('overflowY', 'auto'); 
  });
  
    $("#pcstart").click(function(){
//    $("#pcstart").hide();
    $("#pcstart").css('right' , $('#pc_viewport').width()+'px');
    $('#pcviewportCover').fadeIn(300);
    $('html, body').css('overflowY', 'hidden'); 
    $('#pcviewportCover').css('top', $(document).scrollTop());
    $('#pcviewportCover').css('overflowX', 'hidden');
  });
  
    //  Check Radio-box
    $(".rating input:radio").attr("checked", false);
    $('.rating input').click(function () {
        $(".rating span").removeClass('checked');
        $(this).parent().addClass('checked');
    });

    $('.rating input:radio').change(
    function(){
        var userRating = this.value;
        pc.rating = userRating;
    }); 
  
  //$("#pcNotification").click(function(){
  //  toggleFeature("pcNotificationDetails");  	
  //});

    $("#pcPoints").click(function(){
    togglePointsFeature(); 	
  });

    $("#pcCoupons").click(function(){
    toggleCouponsFeature();
  });

    $("#pcFeedback").click(function(){
    toggleFeedbackFeature();
  });

});
